import { createContext } from "react";

export const RevealingContext = createContext(false);
